import type React from "react"
import "./things-to-know.css"
import OpenEyeIcon from "../../assets/svgs/infoIcon"
import BulletPointIcon from "../../assets/svgs/bulletPointIcon"

// types.ts or within your component file
interface InfoPoint {
  text: string
}

interface PropertyTypeInfo {
  title?: string // Make title optional
  points: InfoPoint[]
}

interface ThingsToKnowProps {
  propertyTypes: PropertyTypeInfo[]
}

const ThingsToKnow: React.FC<ThingsToKnowProps> = ({ propertyTypes }) => {
  return (
    <div className="things-to-know">
      <div className="things-to-know-header">
        <div className="info-icon">
          <OpenEyeIcon />
        </div>
        <h2 className="things-to-know-title">Things to Know</h2>
      </div>

      {propertyTypes.map((propertyType, index) => (
        <div key={index} className="property-type-section">
          {propertyType.title && (
            <h3 className="property-type-title">{propertyType.title}</h3>
          )}
          <ul className="property-info-list">
            {propertyType.points.map((point, pointIndex) => (
              <li key={pointIndex} className="property-info-item">
                <div className="info-point-icon">
                  <BulletPointIcon />
                </div>
                <p className="info-point-text">{point.text}</p>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

export default ThingsToKnow

